(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["frattoli-contact-form"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-frattoli-watch-context]').forEach((input) => {
    const watch = new URLSearchParams(window.location.search).get('watch');
    if (watch && !input.value) input.value = watch.slice(0, 200);
  });
  document.querySelectorAll('[data-frattoli-product-context]').forEach((input) => {
    const product = new URLSearchParams(window.location.search).get('product');
    if (!product || input.value) return;
    try {
      const url = new URL(product, window.location.origin);
      if (url.origin === window.location.origin && url.pathname.startsWith('/products/')) input.value = url.href;
    } catch (_) {}
  });
  } catch(e) { console.error(e); }
})();

})();
